










































































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/cours/edit/EditCours.vue'
import TemplateCoursItem from '@/components/administration/piscine/read/TemplateCoursItem.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine'
import { getImageUrl } from '@/utils/images'
import { formatDate } from '@/filters/formatDate'
import { AloTemplateHoraire } from '@/models/alo/AloTemplateHoraire'
import { toNumberDictionary, toNumberLookup } from '@/utils/groupBy'
import { concat } from '@/utils/string'
import { AloCours, getDefaultAloCours } from '@/models/alo/AloCours'
import { AlsCours } from '@/models/als/AlsCours'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import { directPayloadQuery } from '@/utils/api'
import apiCours from '@/api/cours'
import { CommitAction } from '@/enum/CommitAction'

@Component({
  name: 'ReadGenerateCours',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{TemplateCoursItem,Edit}
})
export default class ReadGenerateCours extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean
  private searching = false
  private saving = false  
  private dates:Array<string> = []   
  private jours = [1,2,3,4,5,6,7]
  private coursIds:Array<number> = []
 
  private get coursDic() {
    return this.$store.myGetters.coursDic
  }
 
  private get cours() {
    return this.coursIds.map(id => this.coursDic[id])
  }
 
  private headers = [       
    { text: 'Date', value: 'crsDatdebut', width:160 },
    { text: 'Cours', value: 'libelle' },    
    { text: 'MNS', value: 'professeur', width:100 },
    { text: 'Inscrits', value: 'inscriptions', width:100 },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private headersNew = [    
    { text: 'Date', value: 'crsDatdebut' },
    { text: 'Cours', value: 'libelle'  },    
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  rowClass(cours:AloCours)  {
    return cours.selected?'new':  new Date(cours.crsDatdebut) < new Date() ?'old':''
  }

  get todayStr(){
    return formatDate(new Date(), "YYYY-MM-DD")
  }

  private get search(){
    return this.$store.myGetters.searchCours
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_COURS(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortCoursDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_COURS_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortCoursBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_COURS_BY(value)
  }

  mounted() {
    this.updateGenerationDate()  
  }

  updateGenerationDate(){
    let start = new Date()    
    const maxCours = new Date(this.piscine.datMaxCours)
    if(maxCours > start) {
      maxCours.setDate(maxCours.getDate()+1)
      start = maxCours
    }
    let nextMonth = new Date()
    nextMonth.setMonth(nextMonth.getMonth() + 1)
    if(nextMonth<start) {
      nextMonth = new Date(start.getTime())
      nextMonth.setDate(nextMonth.getDate()+1)
    }
    this.dates = [formatDate(start,"YYYY-MM-DD"),formatDate(nextMonth,"YYYY-MM-DD")]
  }

  get rangeGeneration() {
    if(this.dates.length == 2) {      
      const date1 = new Date(this.dates[0])      
      const date2 = new Date(this.dates[1])      
      return date1<date2?[date1,date2]:[date2,date1]
    }
    return null
  }

  private get selectedMonth(){ 
    return this.$store.myGetters.monthPiscine
  }

  private set selectedMonth(newMonth){
    this.$store.myActions.UI_SET_MONTH_PISCINE(newMonth.toUTCString())
  }


  get coursMinDate(){
    return this.piscine.datMinCours.length>0?new Date(this.piscine.datMinCours):new Date()
  }

  get coursMaxDate(){
    return this.piscine.datMaxCours.length>0?new Date(this.piscine.datMaxCours):new Date()
  }
  

  private get selectedPeriode() {    
    //@ts-ignore
    return this.selectedMonth.getUTCDate() == 31?this.$options.filters.formatDate(this.selectedMonth,"YYYY"):this.$options.filters.formatDate(this.selectedMonth,"MMMM YYYY")
  }  

  get horairesByJours(){
    return toNumberLookup(this.piscine.templateCours.reduce((crenaux,cours)=> [...crenaux,...cours.horaires],[] as Array<AloTemplateHoraire>),h => h.thrJour)
  }

  get dicTemplateCours(){
    return toNumberDictionary(this.piscine.templateCours, c => c.id)
  }

  get getImageUrl(){
    return getImageUrl
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  get configuration(){    
    return this.$store.myGetters.configuration
  }
  
  get newCours() {
    const cours = [] as Array<AloCours>
    let fid = 1
    if(this.rangeGeneration) {    
    const jour = new Date(this.rangeGeneration[0])
    const last = this.rangeGeneration[1]
    while(jour <= last) {
      if(!!this.horairesByJours[jour.getDay()]) {        
        cours.push(...this.horairesByJours[jour.getDay()].map(th => {
                    return {...getDefaultAloCours(this.dicTemplateCours[th.tcsId],th),crsDatdebut:`${jour.getFullYear()}-${(jour.getMonth()+1).toString().padStart(2,'0')}-${jour.getDate().toString().padStart(2,'0')} ${th.thrHeure.toString().padStart(2,'0')}:${th.thrMinute.toString().padStart(2,'0')}`,libelle:this.textCours(th),fid:fid++}
                  }))
      }
      jour.setDate(jour.getDate()+1)
    }    
    }
    return cours;
  }


  textCours(horaire:AloTemplateHoraire) {   
    const acti = concat(this.activityDic[this.dicTemplateCours[horaire.tcsId].acyId]?.libelle,this.activityDic[horaire.acyIdCplt]?.libelle," / ")
    return `${horaire.libelle} - ${acti}`
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  

  loadCours(dates:Array<Date>){
    this.searching = true    
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(false)
    setTimeout(() => {
      this.$store.myActions.ADM_COURS_REQUEST({
        from:new Date(dates[0]),
        to:new Date(dates[1]),
        psnId:this.piscine.id,
        commit:CommitAction.dicOnly
      }as AlsCours).then((cours)=>{
        this.coursIds = cours.map(c => c.id)
      }).finally(() => {        
        this.searching = false
      })
    }, 
    //@ts-ignore
    this.$vuetify.breakpoint.mobile?200:0);    
  }
 
  openDetail(cours:AloCours){
    (this.$refs.edit as Edit).edit(cours)
  }

  genereCours(){
    this.saving = true
    this.$store.myActions.ADM_COURS_CREATE_RANGE_REQUEST(this.newCours).then((cours)=>{            
      this.coursIds.push(...cours.map(c => c.id));            
      this.$store.myActions.ADM_PISCINE_DETAIL_REQUEST(this.piscine.id).then(()=>{
        this.updateGenerationDate()
      })      
    }).finally(()=>{
      this.saving = false
    })
  }

  createCours(cours:AloCours) {
    this.saving = true
    this.$store.myActions.ADM_COURS_CREATE_REQUEST(cours).then((crs)=>{      
      this.coursIds.push(crs.id)
    }).finally(()=> {
      this.saving = false
    })
  }

  deleteCours(cours:AloCours){
    if(cours.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer le cours "${cours.libelle} du ${formatDate(cours.crsDatdebut,'dddd DD MMMM HH:mm')}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_COURS_DELETE_REQUEST(cours.id).then((crs) => {
            const index = this.coursIds.findIndex(id=>id == crs.id)
            if(index > -1) this.coursIds.splice(index,1)
          })
        } 
      })          
    } 
  }

  addCours() {
    const newCours:AloCours = {
      ...getDefaultAloCours(),
      psnId:this.piscine.id,
      piscine:this.piscine.libelle,
      crsDatdebut:`${formatDate(new Date(),"YYYY-MM-DD")}T14:00:00`
    };
    (this.$refs.edit as Edit).edit(newCours)
  }
}
